/*
 * Broadcast Theme - Custom JavaScript
 */




(function() {

  function playVideo(video) {
    if (!video) return;
    video.muted = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    if (video.paused) {
      video.currentTime = 0;
      var p = video.play();
      if (p !== undefined) p.catch(function(){});
    }
  }


(function() {
  // Detect if customer is on the English version
  var isEnglish = window.location.hostname.startsWith('en.') ||
                  (window.Weglot && window.Weglot.getCurrentLang() === 'en');
  
  if (!isEnglish) return;
  
  // Inject locale into all cart forms
  function injectLocale() {
    document.querySelectorAll('form[action*="/cart"], form[action*="/checkout"]').forEach(function(form) {
      var action = form.getAttribute('action') || '/cart';
      
      // Add to URL
      if (action.indexOf('locale=') === -1) {
        var separator = action.indexOf('?') !== -1 ? '&' : '?';
        form.setAttribute('action', action + separator + 'locale=en');
      }
      
      // Also add as hidden field (belt and suspenders)
      if (!form.querySelector('input[name="locale"]')) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'locale';
        input.value = 'en';
        form.appendChild(input);
      }
    });
  }
  
  // Run on load and any time the cart updates
  document.addEventListener('DOMContentLoaded', injectLocale);
  
  var observer = new MutationObserver(injectLocale);
  observer.observe(document.body, { childList: true, subtree: true });
})();



  document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('.media-video').forEach(playVideo);

    var galleryContainer = document.querySelector('.product__slides, .product-single__photos, .product__media-list');

    if (galleryContainer) {
      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(m) {
          m.addedNodes.forEach(function(node) {
            if (node.nodeType !== 1) return;
            if (node.tagName === 'VIDEO') {
              playVideo(node);
            } else if (node.querySelectorAll) {
              node.querySelectorAll('.media-video, video').forEach(playVideo);
            }
          });
        });
      });
      observer.observe(galleryContainer, { childList: true, subtree: true });
    }

    var slideObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'class') {
          var slide = m.target;
          if (slide.classList.contains('media--active')) {
            var video = slide.querySelector('.media-video');
            if (video) playVideo(video);
          }
        }
      });
    });

    document.querySelectorAll('.product__slide').forEach(function(slide) {
      slideObserver.observe(slide, {
        attributes: true,
        attributeFilter: ['class']
      });
    });

  });

})();